import createPersistedState from 'vuex-persistedstate';

export default new createPersistedState({ key: 'kbm' });
